exports = module.exports = require("./../../../node_modules/.npminstall/css-loader/0.23.1/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page header{background:#ee6e73;color:#fff;padding:10px 0;overflow:hidden}.page header .text-box{width:75%;float:left;padding-left:8%}.page header .text-box h1{font-size:3em;line-height:110%;margin:1em 0}.page header .text-box h4{font-size:2.28em;line-height:110%;margin-top:0;margin-bottom:.5em;-webkit-font-smoothing:antialiased;color:hsla(0,0%,100%,.85)}.page header .card-box{width:25%;float:left}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/css-loader/0.23.1/css-loader!./~/.npminstall/postcss-loader/0.8.2/postcss-loader!./~/.npminstall/less-loader/2.2.3/less-loader!./src/components/Home/index.less
 ** module id = 512
 ** module chunks = 0
 **/